(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/dialog/assets/javascripts/views/payment.js') >= 0) return;  svs.modules.push('/components/components/dialog/assets/javascripts/views/payment.js'); "use strict";

(function (svs) {
  'use strict';

  svs.components.dialog = svs.components.dialog || {};

  class DialogPayment extends svs.components.dialog.Confirm {
    getContent() {
      if (this.options.price && this.options.product) {
        if (this.options.isTicket) {
          this.options.title = "Vill du betala en ".concat(this.options.product, "\xA0f\xF6r\xA0").concat(svs.utils.format.Currency(this.options.price), "\xA0<abbr aria-label=\"kronor\" title=\"kronor\">kr</abbr>");
        } else if (this.options.isVoucher) {
          this.options.title = "Vill du ge bort en ".concat(this.options.product, "\xA0f\xF6r\xA0").concat(svs.utils.format.Currency(this.options.price), "\xA0<abbr aria-label=\"kronor\" title=\"kronor\">kr</abbr>?");
        } else if (this.options.isBag) {
          const payString = this.isSelfService() ? 'spela' : 'betala';
          this.options.title = "Vill du ".concat(payString, " ").concat(this.options.product, "\xA0f\xF6r\xA0").concat(svs.utils.format.Currency(this.options.price), "\xA0<abbr aria-label=\"kronor\" title=\"kronor\">kr</abbr>?");
        } else {
          this.options.title = "Vill du betala ett spel p\xE5 ".concat(this.options.product, "\xA0f\xF6r\xA0").concat(svs.utils.format.Currency(this.options.price), "\xA0<abbr aria-label=\"kronor\" title=\"kronor\">kr</abbr>?");
        }
      }

      return new this.options._ContentClass(this.options);
    }

    isSelfService() {
      return Boolean(svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService') && svs.core.config.data.svsconfig.isSelfService);
    }

  }

  svs.components.dialog.Payment = DialogPayment;
})(svs);
 })(window);